export default __webpack_public_path__ + "static/media/1v1.e7df28e2.jpg";